import intlTelInput from 'intl-tel-input';
// Load matching utilities with the pack: a failed CDN script rejects the widget's
// promises with undefined and prevents phone numbers being formatted for sign-in.
import 'intl-tel-input/build/js/utils';

const input = document.querySelector("#phone");
const iti = intlTelInput(input, {
    nationalMode: true,
    separateDialCode: false,
    initialCountry: 'us'
});

const handleChange = function(){
  $('#phone').val(iti.getNumber())
}

input.addEventListener("countrychange", handleChange)
input.addEventListener('change', handleChange)